"use client";

import Link from "next/link";
import Image from "next/image";
import {
  FacebookIcon,
  InstagramIcon,
  LinkedinIcon,
  YoutubeIcon,
  TiktokIcon,
} from "./SocialIcons";

export default function Footer() {
  const socialMedia = [
    {
      name: "Facebook",
      icon: <FacebookIcon size={20} />,
      link: "https://www.facebook.com/SOMOSADISES/",
    },
    {
      name: "Instagram",
      icon: <InstagramIcon size={20} />,
      link: "https://www.instagram.com/somosadises/",
    },
    {
      name: "LinkedIn",
      icon: <LinkedinIcon size={20} />,
      link: "https://www.linkedin.com/company/somosadises/",
    },
    {
      name: "YouTube",
      icon: <YoutubeIcon size={20} />,
      link: "https://www.youtube.com/channel/UCbOHXJn7HntXuFMupVrkClQ",
    },
    {
      name: "TikTok",
      icon: <TiktokIcon size={20} />,
      link: "https://www.tiktok.com/@somosadises",
    },
  ];
  return (
    <footer className=" bg-white bottom-0 mt-8 h-auto w-full border-t border-slate-200">
      <div className="grid grid-cols-1 xs:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 xl:gap-8 max-w-7xl 2xl:max-w-[1400px] mx-auto px-4 sm:px-6 xl:px-8">
        <div className="col-span-1 xs:col-span-2 lg:col-span-1 p-4 sm:p-6 flex items-center xs:items-start flex-col text-center xs:text-left">
          <div>
            <Link
              href="/"
              className="flex items-center gap-3 hover:opacity-90 transition-opacity"
            >
              <Image
                src="/Logoazulhorizontal.png"
                alt="Adises"
                width={200}
                height={53}
                style={{ height: "auto" }}
                className="w-[160px] sm:w-[180px] lg:w-[200px]"
              />
            </Link>
          </div>
          <div>
            <p className=" text-xs mt-2 text-center xs:text-justify mb-2">
              Mayorista en Soluciones de Seguridad Integrada Videovigilancia,
              Control de Acceso, Detección Incendio, Energía, Redes e Intrusión.
            </p>
            <div className="flex gap-2 justify-center xs:justify-start">
              {socialMedia.map((item, index) => (
                <a
                  key={index}
                  href={item.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={`Visitar nuestro perfil de ${item.name}`}
                  className="group cursor-pointer color-white mt-1 bg-white p-2 rounded-2xl justify-center items-center flex text-black hover:bg-secondary hover:text-white transition-colors"
                >
                  {item.icon}
                </a>
              ))}
            </div>
          </div>
        </div>
        <div className="col-span-1 p-4 sm:p-6 flex items-center xs:items-start flex-col text-center xs:text-left">
          <p className="font-bold text-lg ">Productos</p>
          <Link
            href="/productos?isFeatured=true&sort=RECOMMENDED_SCORE"
            className="text mt-2 cursor-pointer text-xs hover:text-blue-500 hover:font-bold transition-colors"
          >
            LISTA GENERAL
          </Link>
        </div>
        <div className="col-span-1 p-4 sm:p-6 flex items-center xs:items-start flex-col text-center xs:text-left">
          <p className="font-bold text-lg">Servicio</p>
          <Link
            href="/proyectos"
            className="mt-2 text-xs hover:text-blue-500 hover:font-bold transition-colors cursor-pointer"
          >
            PROYECTOS
          </Link>
          <Link
            href="/soporte"
            className="mt-1 text-xs  hover:text-blue-500 hover:font-bold transition-colors cursor-pointer"
          >
            SOPORTE TECNICO
          </Link>
          <Link
            href="/contacto"
            className="mt-1 text-xs hover:text-blue-500 hover:font-bold transition-colors cursor-pointer"
          >
            CONTACTO
          </Link>
        </div>
        <div className="col-span-1 p-4 sm:p-6 flex items-center xs:items-start flex-col text-center xs:text-left">
          <p className="font-bold text-lg">Legal</p>
          <Link
            href="/somos-adises"
            className="mt-1 text-xs hover:text-blue-500 hover:font-bold transition-colors cursor-pointer"
          >
            SOMOS ADISES
          </Link>
          <Link
            href="/aviso-de-privacidad"
            className="mt-1 text-xs hover:text-blue-500 hover:font-bold transition-colors cursor-pointer"
          >
            AVISO DE PRIVACIDAD
          </Link>
          <Link
            href="/terminos-y-condiciones"
            className="mt-1 text-xs hover:text-blue-500 hover:font-bold transition-colors cursor-pointer"
          >
            TÉRMINOS Y CONDICIONES
          </Link>
        </div>
      </div>
    </footer>
  );
}
